import Form from './Form';

export default Form;



// WEBPACK FOOTER //
// ./src/pages/gdpr-assessment-tool/containers/Form/index.js